export default {
    ERROR_EN_REGISTRO: 'ERROR EN REGISTRO ',
    ERROR_AL_TRAER_LOS_PRODUCTOS: 'ERROR AL TRAER LOS PRODUCTOS',
    ERROR_EN_CONSULTAR_CODIGO_PROMOCIONALES: 'ERROR EN CONSULTAR CODIGO PROMOCIONALES',
    ERROR_AL_OBTENER_DATOS_DE_CARTERA: 'ERROR AL OBTENER DATOS DE CARTERA',
    ERROR_AL_AGREGAR_INFORMACION_ADICIONAL: 'ERROR AL AGREGAR INFORMACION ADICIONAL',
    ERROR_AL_VALIDAR_LOS_DATOS_DEL_CLIENTE: 'ERROR AL VALIDAR LOS DATOS DEL CLIENTE',
    ERROR_EN_OTP: 'ERROR EN OTP',
    ERROR_AL_AGREGAR_INTERVINIENTE: 'ERROR AL AGREGAR INTERVINIENTE',
    ERROR_AL_ELIMINAR_INTERVINIENTE: 'ERROR AL ELIMINAR INTERVINIENTE',
    ERROR_AL_EDITAR_INTERVINIENTE: 'ERROR AL EDITAR INTERVINIENTE',
    ERROR_AL_ENVIAR_INVITACION: 'ERROR AL ENVIAR INVITACION',
    ERROR_AL_CONFIGURAR_TARJETA_DE_CREDITO: 'ERROR AL CONFIGURAR TARJETA DE CREDITO',
    ERROR_AL_CONFIGURAR_TARJETA_DE_DEBITO: 'ERROR AL CONFIGURAR TARJETA DE DEBITO',
    ERROR_CASO_EMPLEADO: 'ERROR CASO EMPLEADO',
    ERROR_CASO_CUENTA_PROPIA: 'ERROR CASO CUENTA PROPIA',
    ERROR_CASO_PENSIONISTA: 'ERROR CASO PENSIONISTA',
    ERROR_CASO_CUENTA_AJENA: 'ERROR CASO CUENTA AJENA',
    ERROR_CASO_DESEMPLEADO: 'ERROR CASO DESEMPLEADO',
    ERROR_AL_VERIFICAR_FIOC: 'ERROR AL VERIFICAR FIOC',
    ERROR_EN_STAND_BY_INTERMEDIO_AL_TRAER_DATOS_INTERV: 'ERROR EN STAND BY INTERMEDIO AL TRAER DATOS INTERV',
    ERROR_EN_IDENTIFICACION: 'ERROR EN IDENTIFICACION',
    ERROR_CASO_IBAN: 'ERROR CASO IBAN',
    ERROR_CASO_TRANSFERENCIA: 'ERROR CASO TRANSFERENCIA',
    ERROR_CASO_VIDEOLLAMADA: 'ERROR CASO VIDEOLLAMADA',
    ERROR_CASO_VIDEOSELFIE: 'ERROR CASO VIDEOSELFIE',
    ERROR_CASO_EN_OFICINA: 'ERROR CASO EN OFICINA',
    ERROR_CASO_EN_DOMICILIO: 'ERROR CASO EN DOMICILIO',
    ERROR_AL_ENVIAR_CONTENIDO_GDPR: 'ERROR AL ENVIAR CONTENIDO GDPR',
    ERROR_AL_CREAR_EL_CONTRATO: 'ERROR AL CREAR EL CONTRATO',
    ERROR_EN_DOCUMENTACION: 'ERROR EN DOCUMENTACION',
    ERROR_AL_CONFIRMAR_DOCUMENTACION: 'ERROR AL CONFIRMAR DOCUMENTACION',
    ERROR_AL_SUBIR_DOCUMENTACION: 'ERROR AL SUBIR DOCUMENTACION',
    ERROR_AL_REGISTRARSE_UN_INTERVINIENTE: 'ERROR AL REGISTRARSE UN INTERVINIENTE',
    ERROR_AL_VALIDAR_IBAN_FORMATO: 'error iban incorrecto / formato',
    ERROR_AL_VALIDAR_IBAN_ENTIDAD: 'error iban incorrecto / validacion por entidad bancaria ',
    ERROR_IBAN_INPUT: 'error-input',
    ERROR_IBAN_SERVICIO: 'error-servicio',
    ERROR_DOSSIER: 'ERROR AL TRAER EL DOSSIER',
};
